export default __webpack_public_path__ + "static/media/logo_dark4.779f720d.png";